module.exports = __webpack_public_path__ + "static/media/metodo.f326bfb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/metodo.png
// module id = 1195
// module chunks = 0